import DefaultStyle from './definitions/DefaultStyle';
import TechStyle from './definitions/TechStyle';
import ProfessionalStyle from './definitions/ProfessionalStyle';
import BlankStyle from './definitions/BlankStyle';
// Import other style definitions here

// Registry Map
export const STYLES = {
  [DefaultStyle.id]: DefaultStyle,
  [TechStyle.id]: TechStyle,
  [ProfessionalStyle.id]: ProfessionalStyle,
  [BlankStyle.id]: BlankStyle,
  // Add other styles here
};

// Default Style ID
export const DEFAULT_STYLE_ID = 'default';

// Get all styles as an array
export const getAllStyles = () => {
  return Object.values(STYLES);
};

// Get a specific style by ID
export const getStyleById = (id) => {
  return STYLES[id] || STYLES[DEFAULT_STYLE_ID]; // Fallback to default style
};

// Helper function to get translated style names
export const getTranslatedStyleName = (styleId, t) => {
  return t(`styles.${styleId}`) || STYLES[styleId]?.name;
};

// Helper function to get translated style description
export const getTranslatedStyleDescription = (styleId, t) => {
  return t(`styles.descriptions.${styleId}`) || STYLES[styleId]?.description;
};

// Export all functions and the registry itself
export default {
  STYLES,
  DEFAULT_STYLE_ID,
  getAllStyles,
  getStyleById,
  getTranslatedStyleName,
  getTranslatedStyleDescription,
}; 